/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PdfDownloadResponse
 */
export interface PdfDownloadResponse {
    /**
     * Signed URL to download the combined PDF
     * @type {string}
     * @memberof PdfDownloadResponse
     */
    download_url?: string;
}

/**
 * Check if a given object implements the PdfDownloadResponse interface.
 */
export function instanceOfPdfDownloadResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PdfDownloadResponseFromJSON(json: any): PdfDownloadResponse {
    return PdfDownloadResponseFromJSONTyped(json, false);
}

export function PdfDownloadResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PdfDownloadResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'download_url': !exists(json, 'download_url') ? undefined : json['download_url'],
    };
}

export function PdfDownloadResponseToJSON(value?: PdfDownloadResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'download_url': value.download_url,
    };
}

